import React, { useEffect, useState } from "react";
import {
  createCompany,
  createCompanySuccessful,
} from "../../../store/auth/register/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";

import AppModal from "../../Common/AppModal";
import {
  getCompanyToUserList,
  getCompanyToUserListSuccess,
  switchCompany,
  switchCompanySuccess,
} from "../../../store/companyToUser/action";
import { isEmpty } from "lodash";
import { BusinessDetailsTab } from "./businessDetailsTab";
import { RegistrationAndVatTab } from "./registrationAndVatTab";
import { BrandingTab } from "./brandingTab";

export default function CreateNewCompany({
  modal,
  setModal,
  toggle,
  createAndSelect,
}) {
  const dispatch = useDispatch();
  const createCompanyInit = {
    BusinessName: "",
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostCode: "",
    AddressCountry: "",
    RegNo: "",
    VatNo: "",
    ContactTelephoneNumber: "",
    ContactEmailAddress: "",
    FlagVatEnabled: "",
    LogoUrl: "",
    WebsiteUrl: "",
    YearEndDateFirst: "",
  };

  const [createCompanyData, setCreateCompanyData] = useState(createCompanyInit);
  console.log("createCompanyData", createCompanyData);
  const [companyCreatedSuccess, setCompanyCreatedSuccess] = useState(false);
  const { createCompanySuccessAPI, createCompanyLoadingAPI } = useSelector(
    (state) => ({
      createCompanySuccessAPI: state.Account.createCompanySuccess,
      createCompanyLoadingAPI: state.Account.createCompanyLoading,
    })
  );

  const handleCreateCompany = () => {
    dispatch(createCompany([createCompanyData]));
  };
  useEffect(() => {
    if (isEmpty(createCompanySuccessAPI)) return;
    if (createCompanySuccessAPI.status === 200) {
      toast.success(createCompanySuccessAPI.message);
      dispatch(getCompanyToUserListSuccess([]));
      dispatch(getCompanyToUserList());
      setCompanyCreatedSuccess(true);
      // setModalSelectCompany(true);
      handleSwitchCompany(createCompanySuccessAPI?.Company_IdExternal);
    } else {
      toast.error(createCompanySuccessAPI.message);
    }
    dispatch(createCompanySuccessful([]));
  }, [createCompanySuccessAPI]);

  const { companyToUserList, getCompanySwitchListLoadingAPI } = useSelector(
    (state) => ({
      companyToUserList:
        state.CompanyToUser.companyToUserList?.companytouser_list,
      getCompanySwitchListLoadingAPI:
        state.CompanyToUser.getCompanySwitchListLoading,
    })
  );
  const lastItem = companyToUserList
    ? companyToUserList[companyToUserList?.length - 1]
    : null;

  useEffect(() => {
    if (isEmpty(companyToUserList)) return;
    if (!companyCreatedSuccess) return;
    if (getCompanySwitchListLoadingAPI) return;

    if (createAndSelect) {
      const lastItem = companyToUserList[companyToUserList?.length - 1];

      handleSwitchCompany(lastItem?.Company_IdExternal);
      setCreateCompanyData(createCompanyInit);
      setCompanyCreatedSuccess(false);
    } else {
      dispatch(getCompanyToUserList());
      setModal(false);
      setCreateCompanyData(createCompanyInit);
      setCompanyCreatedSuccess(false);
    }
  }, [
    companyToUserList,
    companyCreatedSuccess,
    getCompanySwitchListLoadingAPI,
  ]);

  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const handleSwitchCompany = (id) => {
    dispatch(switchCompany({ id: id }));
    setSelectedCompanyId(id);

    let authUser = JSON.parse(localStorage.getItem("authUser"));
    authUser.get_user_data.Company_IdExternal = id;
    localStorage.setItem("authUser", JSON.stringify(authUser));
  };
  const { companySwitchSuccessAPI } = useSelector((state) => ({
    companySwitchSuccessAPI: state.CompanyToUser.companySwitch,
  }));

  useEffect(() => {
    if (isEmpty(companySwitchSuccessAPI)) return;
    if (companySwitchSuccessAPI.status === 200) {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      authUser.token = companySwitchSuccessAPI.token;
      authUser.get_staff_data = companySwitchSuccessAPI.get_staff_data;
      authUser.get_company_data = companySwitchSuccessAPI.get_company_data;
      // Refresh per-company config on switch (same reason as SelectCompany):
      // otherwise the timer/etc keep reading the previous company's config
      // (e.g. ZCONFIGVAL_14_X default_timer_product) -> "#<staleId>, undefined".
      if (companySwitchSuccessAPI?.get_configitem_data) {
        authUser.get_configitem_data =
          companySwitchSuccessAPI.get_configitem_data;
      }
      // Change #100127 - the new company's modules, as SelectCompany does.
      if (Array.isArray(companySwitchSuccessAPI?.get_systemmodule_list)) {
        authUser.get_systemmodule_list =
          companySwitchSuccessAPI.get_systemmodule_list;
      }
      // Refresh per-company security lists on switch (aligned with SelectCompany):
      // otherwise permissions/roles/team members stay stale for the previous
      // company right after creating and switching into the new one.
      authUser.get_securityauthcapability_list =
        companySwitchSuccessAPI.get_securityauthcapability_list;
      authUser.get_securityauthrole_list =
        companySwitchSuccessAPI?.get_securityauthrole_list;
      authUser.get_staffteammembers_list =
        companySwitchSuccessAPI?.get_staffteammembers_list
          ? companySwitchSuccessAPI?.get_staffteammembers_list
          : [];

      // Same treatment as SelectCompany: trust the response for the company
      // id, tolerate a snapshot with no get_user_data, and store the switched
      // session before anything can re-render against the old company.
      const var___switched_company_id =
        companySwitchSuccessAPI?.get_company_data?.Company_IdExternal ||
        selectedCompanyId;
      if (!authUser.get_user_data) {
        authUser.get_user_data = {};
      }
      authUser.get_user_data.Company_IdExternal = var___switched_company_id;

      localStorage.setItem("authUser", JSON.stringify(authUser));
      setModal(false);

      // replace, not href: the pre-switch page must not stay in history.
      window.location.replace(
        "/" + companySwitchSuccessAPI?.get_staff_data?.OpeningUrl
      );
    } else {
      toast.error(companySwitchSuccessAPI.message);
    }
    dispatch(switchCompanySuccess([]));
  }, [companySwitchSuccessAPI]);
  // convert file to base64
  const handleFileConvertToBase64 = (file) => {
    // Check if the file is an image if it is convert to base 64 and return it
    if (file.type.match("image.*")) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setCreateCompanyData({
          ...createCompanyData,
          LogoUrl: reader.result,
        });
      };
      reader.onerror = (error) => {
        //
      };
      return reader.result;
    }
  };
  const [activeTab, setActiveTab] = useState(1);
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const handleCheckEachStep = (activeTab) => {
    // Mandatory fields from Step1. : BusinessName, address Line 1, City, Postcode.
    if (createCompanyData?.BusinessName === "") {
      toast.error("Business Name is required");
      setActiveTab(1);
      return;
    }

    toggleTab(activeTab);
  };
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title="Create New Business"
      icon={<AddBusinessOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={createCompanyLoadingAPI}
      loadingText="One moment, we're building your account."
      hideFooter
    >
      <BusinessDetailsTab
        createCompanyData={createCompanyData}
        setCreateCompanyData={setCreateCompanyData}
        toggleTab={toggleTab}
        activeTab={activeTab}
        handleCheckEachStep={handleCheckEachStep}
        handleCreateCompany={handleCreateCompany}
      />
    </AppModal>
  );
}
